(function () {
  'use strict';

  angular.module('eclipseApp.myAccount')

    .controller('internetAccountCtrl', ['$scope', '$rootScope', '$http', 'uteEndpoint', 'uteModal', '$stateParams', '$modal', '$filter', 'commonService', 'changeTechInstallService', 'dtmService','dtmServiceConstants','$state', 'uteLocale', function ($scope, $rootScope, $http, uteEndpoint, uteModal, $stateParams, $modal, $filter, commonService, changeTechInstallService, dtmService, dtmServiceConstants, $state, uteLocale) {

      $scope.commonService = commonService;
      $scope.packageMode = 'change';
      $scope.selectedPackageIdx = 1;
      $scope.activePackageIdx = 1;
      $scope.existingProductDetailsExecuted = false;
      $scope.hasTechInstallAppointment = false;
      $scope.productInfo = 'LOADING';
      $scope.changeInternetActions = {};
      $scope.changeInternetActions.eligible = true;

      /**
       * mapped language
       * @type {Function}
       */
      $scope.language = uteLocale.language;

      // DC-188: code cleanup, following moved to route resolve

      /* if ($stateParams.accountNumber && $stateParams.subscriberNo) {
        $rootScope.userInfo.selectedAccountNumber = $stateParams.accountNumber;
        $rootScope.userInfo.selectedSubscriberNo = $stateParams.subscriberNo;
      } else if ((!$stateParams.accountNumber && !$rootScope.userInfo.selectedAccountNumber) || (!$stateParams.subscriberNo && !$rootScope.userInfo.selectedSubscriberNo)) {
        $state.go('myAccount.overview');
      } else {
        if (!$stateParams.accountNumber) {
          $stateParams.accountNumber = $rootScope.userInfo.selectedAccountNumber;
        }
        if (!$stateParams.subscriberNo) {
          $stateParams.subscriberNo = $rootScope.userInfo.selectedSubscriberNo;
        }
      } */

      // TODO improve handling of 60010 on change internet package flow
      $scope.$on('notEligible', function () {
        $scope.changeInternetActions.eligible = false;
      });

      if ($stateParams.accountNumber) {
        var currentAccount = _.find($rootScope.userInfo.accounts, function (account) {
          return account.accountNumber === $stateParams.accountNumber;
        });
        if (currentAccount && (currentAccount.status === 'SUSPENDED' || currentAccount.status === 'CANCELLED')) {
          $state.go('myAccount.overview');
        }
      }

      $scope.showLiveChat = false;

      if ($rootScope.ruiMethods && $rootScope.ruiMethods.user && $rootScope.ruiMethods.user.is) {
        $scope.showLiveChat = !$rootScope.ruiMethods.user.is.agent();
      }

      $scope.tabData = [
        {
          heading: 'global.label.changePackage',
          route: 'myAccount.internet.package'
        }
      ];
      /**
       * by default the selected tier should be the first one in the sorted list
       * @type {number}
       */
      $scope.selectedTier = 1;

      /**
       * the length of the data coming from SS
       * @type {number}
       */
      $scope.totalTiers = 0;

      /**
       * Click function to determine what tier has been selected
       * @activeTier
       */
      $scope.isSelectedTier = function (activeTier) {
        $scope.selectedTier = activeTier + 1;
      };


      $scope.exchangeHardware = function () {
        if (!$rootScope.ruiMethods.user.is.agent()) {
          uteModal.open({
            templateUrl: 'modules/my-account/internet/exchange-hardware-modal.html',
            controller: 'exchangeHardwareCtrl',
            size: 'lg'
          });
        }
        else {
          uteModal.open({
            templateUrl: 'views/templates/modal/self-serve-modem-modal.html',
            controller: 'selfServeModemCtrl',
            resolve: {
              action: 'exchange-modem',
              orderId: $rootScope.userInfo.selectedAccountNumber
            }
          });
        }

      };


      $scope.showTermsConditionsModal = function () {
        uteModal.open({
          templateUrl: 'modules/internet/views/internet-more-details-terms.html',
          size: 'lg',
          scope: $scope,
          controller: 'internetAccountCtrl'
        });
      };


      // checking if user has tech install appointment.
      if (changeTechInstallService.getOrderInfo() && changeTechInstallService.getOrderInfo().error != '50000' && changeTechInstallService.getOrderInfo().error != '60005') {
        $http({
          url: uteEndpoint('v1/viewInstallationAppointment'),
          method: 'POST',
          //params: params,
          cache: false
        }).then(function (resp) {

          if (resp.data && resp.data.getCurrentTechInstallAppointment && !resp.data.getCurrentTechInstallAppointment.error) {
            if (!resp.data.getCurrentTechInstallAppointment.error)
              changeTechInstallService.currentTechInstallAppointment = resp.data.getCurrentTechInstallAppointment;
            $scope.hasTechInstallAppointment = true;
          }
          else
            $scope.hasTechInstallAppointment = false;

        }, function (resp) {
          $scope.hasTechInstallAppointment = true;
        });
      }
      else
        $scope.hasTechInstallAppointment = false;

      $scope.changeTechAppt = function () {
        uteModal.open({
          templateUrl: 'modules/my-account/internet/change-appointment-modal.html',
          size: 'lg',
          controller: ['changeTechInstallService', '$scope', '$state', function (changeTechInstallService, $scope, $state) {

            $scope.currentTechInstallAppointment = changeTechInstallService.currentTechInstallAppointment;
            $scope.loadError = !$scope.currentTechInstallAppointment;
            $scope.submitChangeAppointment = function () {
              $state.go('myAccount.internet.changeTechInstall', $state.params);
            };
            $scope.language = uteLocale.language;

          }]
        });
      };

      //$scope.changeTechAppt = function () {
      //  if(changeTechInstallService.getOrderInfo() && changeTechInstallService.orderInfo.error != '50000' && changeTechInstallService.orderInfo.error != '60005') {
      //    uteModal.open({
      //      templateUrl: 'modules/my-account/internet/change-appointment-modal.html',
      //      size: 'lg',
      //      controller: function ($scope, $state) {
      //
      //        $scope.loadError = false;
      //
      //        $http({
      //          url: uteEndpoint('v1/viewInstallationAppointment'),
      //          //url: uteEndpoint('v1/getCurrentTechInstallAppointment'),
      //          method: 'POST',
      //          //params: params,
      //          cache: false
      //        }).then(function (resp) {
      //          if (resp.data && resp.data.getCurrentTechInstallAppointment && !resp.data.getCurrentTechInstallAppointment.error) {
      //
      //            $scope.currentTechInstallAppointment = resp.data.getCurrentTechInstallAppointment;
      //
      //            $scope.submitChangeAppointment = function () {
      //              $state.go('myAccount.internet.changeTechInstall', $state.params);
      //            };
      //
      //            $scope.language = uteLocale.language;
      //          }
      //          else {
      //            $scope.loadError = true;
      //          }
      //        }, function (resp) {
      //          $scope.loadError = true;
      //        });
      //      }
      //    });
      //  }
      //};

      $scope.resetModem = function () {
        $scope.resetModemSuccess = false;
        $scope.resetModemError = false;
        dtmService.start(dtmServiceConstants.dtmRules.dtmInternetResetModem.ruleName,dtmServiceConstants.type.active,dtmServiceConstants.actions.startEvent);
        $modal.open({
          templateUrl: 'modules/my-account/internet/reset-modem-modal.html',
          scope: $scope
        });
      };

      $scope.cancelInternet = function () {
        dtmService.start(dtmServiceConstants.dtmRules.dtmCancelInternet.ruleName,dtmServiceConstants.type.active,dtmServiceConstants.actions.startEvent);
        $modal.open({
          templateUrl: 'modules/my-account/internet/cancel-internet.html',
          scope: $scope
        });
      };

      $scope.dtmCancelInternet = function () {
        dtmService.complete(dtmServiceConstants.dtmRules.dtmCancelInternet.ruleName);
      };

      $scope.submitResetModem = function () {
        $http.post(uteEndpoint('v2/resetPin'), {
          data: {
            subscriptionid: $rootScope.subscriberNo,
            accountNumber: $rootScope.accountNumber,
            pinType: ''
          }
        }).then(
          function (result) { // success
            $scope.resetModemSuccess = true;
            dtmService.complete(dtmServiceConstants.dtmRules.dtmInternetResetModem.ruleName);
          },
          function (error) { // error
            $scope.resetModemError = true;
            var resetModemSsError = 'SS|' + dtmServiceConstants.dtmRules.dtmInternetResetModem.defaultServerError;
            dtmService.setVar(dtmServiceConstants.dtmRules.dtmInternetResetModem.eVar, resetModemSsError);
            dtmService.direct(dtmServiceConstants.dtmRules.dtmInternetResetModem.errorRuleName);
          }
        );
      };

      var loadDailyData = function (usageDetails) {
        $scope.dailyUsage = [];
        var monthlyUsageLimit = 0;

        if (usageDetails && usageDetails.dailyUsageSummary && usageDetails.dailyUsageSummary.dailyUsage) {
          $scope.dailyUsage = _.sortBy(usageDetails.dailyUsageSummary.dailyUsage, function (dailyUsage) {
            return dailyUsage.date;
          });
        }

        if (usageDetails && usageDetails.dailyUsageSummary && usageDetails.dailyUsageSummary.totalDailyUsage) {
          var dailyUsageSummaryMB = _.find(usageDetails.dailyUsageSummary.totalDailyUsage, function (dailyUsage) {
            return dailyUsage.unit === 'MB';
          });

          if (dailyUsageSummaryMB) {
            monthlyUsageLimit = dailyUsageSummaryMB.planLimit;
          }
        }

        console.log('monthlyUsageLimit', monthlyUsageLimit);

        var labels = [],
          firstOver = true,
          dailyUnderData = [],
          dailyOverData = [],
          cumulativeChartData = [],
          totalSum = 0;

        _.each($scope.dailyUsage, function (usage) {

          //usage.download = parseInt(usage.download.toFixed(0), 10);
          //usage.upload = parseInt(usage.upload.toFixed(0), 10);
          //usage.total = parseInt(usage.total.toFixed(0), 10);

          labels.push($filter('date')(usage.date, 'MMM d'));
          //$scope.usageData[$scope.selectedMonthIndicator].sum.upload = $scope.usageData[$scope.selectedMonthIndicator].sum.upload + usage.upload;
          //$scope.usageData[$scope.selectedMonthIndicator].sum.download = $scope.usageData[$scope.selectedMonthIndicator].sum.download + usage.download;

          totalSum += usage.total;

          cumulativeChartData.push(totalSum);

          if (totalSum <= monthlyUsageLimit) {

            dailyUnderData.push(usage.total);
            dailyOverData.push(null);

          } else if (totalSum > monthlyUsageLimit && firstOver) {

            dailyUnderData.push(usage.total);
            dailyOverData.push(usage.total);
            firstOver = false;

          } else if (totalSum > monthlyUsageLimit && !firstOver) {

            dailyUnderData.push(null);
            dailyOverData.push(usage.total);

          }

        });

        /*var labels = [],
         dailyData = [],
         foundBreakIndex = false,
         currentTotal = 0;

         _.each($scope.dailyUsage, function (usage, index) {
         //usage.total = usage.upload + usage.download;
         labels.push($filter('date')(usage.date, 'MMM d'));
         currentTotal += usage.total;
         if (currentTotal > monthlyUsageLimit && !foundBreakIndex) {
         foundBreakIndex = true;
         $scope.breakLineOptions = {
         enabled: true,
         breakOn: index
         };
         }
         dailyData.push(usage.total);
         });

         if (!foundBreakIndex && ($scope.dailyUsage || []).length > 0) {
         foundBreakIndex = true;
         $scope.breakLineOptions = {
         enabled: true,
         breakOn: $scope.dailyUsage.length - 1
         };
         }*/

        /**
         * dashboard chart data
         */
        $scope.lineDailyData = {
          labels: labels,
          series: [
            dailyUnderData,
            dailyOverData
          ]
        };

        /**
         * dashboard chart options
         */
        $scope.lineDailyOptions = {
          showPoint: false,
          fullWidth: true,
          height: 200,
          lineSmooth: false,
          low: 0,
          // If the line will stop drawing when the data ends rather than normalizing. This will not manipulate data with multiple length.
          allowVariableDataLengths: true,
          chartPadding: {
            right: 10
          },
          axisY: {
            labelInterpolationFnc: function (value, index, axis) {

              if (index === axis.length - 1) {
                return 'MB</br>' + value;
              } else {
                return value;
              }
            },
            labelOffset: {
              x: 0,
              y: 5
            }
          },
          axisX: {
            labelInterpolationFnc: function (value, index) {
              // only show the first and last label
              if (index === 0 || index === labels.length - 1) {
                return value;
              } else if (index % 1 === 0) {
                return ' ';
              } else {
                return false;
              }
            },
            showGrid: false
          }
        };

        if (dailyUnderData && (dailyUnderData || []).length > 0) {
          $scope.dailyChartStatus = 'SUCCESS';
        } else {
          if (usageDetails && usageDetails.error) {
            $scope.dailyChartStatus = 'ERROR';
          } else {
            $scope.dailyChartStatus = 'NO-DATA';
          }
        }
      };

      var init = function () {

        $rootScope.subscriberNo = $stateParams.subscriberNo;
        $rootScope.accountNumber = $stateParams.accountNumber;

        $scope.accountNumber = $stateParams.accountNumber || $rootScope.userInfo.selectedAccountNumber;
        $scope.subscriberNo = $stateParams.subscriberNo  || $rootScope.userInfo.selectedSubscriberNo;

        $scope.dailyChartStatus = 'LOADING';

        var existingProductDetailsURL = uteEndpoint('v1/existingProductDetails');

        $http.post(existingProductDetailsURL, {
          accountNumber: $scope.accountNumber,
          subscriptionID: $scope.subscriberNo
        }).then(function (resp) {
          $scope.existingProductDetailsExecuted = true;
          $scope.productInfo = resp.data.getExistingHSIPackageInfo;
          if ($scope.productInfo && $scope.language && $scope.productInfo[$scope.language] && $scope.productInfo[$scope.language].usageAllowance) {
            $scope.productInfo[uteLocale.language].usageAllowance = $scope.productInfo[uteLocale.language].usageAllowance.replace('GBPS', 'GB');
          }
        }, function () {
          $scope.productInfo = 'ERROR';
            _satellite.setVar( "error", "FHSI | buy  failed");
                          _satellite.track("bfa-fhsi-error");
        });

        var productConsolidatedUsageSummaryURL = uteEndpoint('v1/productConsolidatedUsageSummary');

        $http.post(productConsolidatedUsageSummaryURL, {
          prodSpec: 'hsi',
          accountNumber: $scope.accountNumber,
          subscriptionID: $scope.subscriberNo
        }).then(function (resp) {
          if (resp && resp.data && resp.data.getDataHSIUsageSummary) {
            $scope.usageSummary = resp.data.getDataHSIUsageSummary;
          } else {
            $scope.usageSummary = { error: '50000' };
            $scope.dailyChartStatus = "ERROR";
              _satellite.setVar( "error", "FHSI | buy  failed");
                            _satellite.track("bfa-fhsi-error");
          }

          $scope.usageSummary.usageMeter = Math.round($scope.usageSummary.usageMeter);

          if ($scope.usageSummary && $scope.usageSummary.usageMeter > 100) {
            $scope.usageSummary.usageMeter = 100;
          }

          if (resp && resp.data && resp.data.getUsageDetails) {
            loadDailyData(resp.data.getUsageDetails);
          } else {
            loadDailyData();
          }
        }, function () {
          $scope.usageSummary = { error: '50000' };
          $scope.dailyChartStatus = "ERROR";
            _satellite.setVar( "error", "FHSI | buy  failed");
                          _satellite.track("bfa-fhsi-error");
        });

      };

      init();

    }]);

})();
